"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VirtualDemocracy = void 0;
const GlobalEventName_1 = require("../GlobalEventName");
const PartyName_1 = require("../../parties/PartyName");
const SendDelegateToArea_1 = require("../../../deferredActions/SendDelegateToArea");
class VirtualDemocracy {
    constructor() {
        this.name = GlobalEventName_1.GlobalEventName.VIRTUAL_DEMOCRACY;
        this.description = 'Place a delegate for every 2 City tiles (max 5 sets). Influence counts as City tiles.';
        this.revealedDelegate = PartyName_1.PartyName.TRANSHUMANS;
        this.currentDelegate = PartyName_1.PartyName.BUREAUCRATS;
    }
    resolve(game, turmoil) {
        game.getPlayers().forEach((player) => {
            const citiesCount = Math.floor((player.getCitiesCount() + turmoil.getPlayerInfluence(player)) / 2);
            const amount = Math.min(citiesCount, 5);
            const playerHasLobbyDelegate = turmoil.lobby.has(player.id);
            let availablePlayerDelegates = turmoil.getDelegatesInReserve(player.id);
            if (playerHasLobbyDelegate)
                availablePlayerDelegates += 1;
            const qty = Math.min(amount, availablePlayerDelegates);
            for (let i = 0; i < qty; i++) {
                const fromLobby = (i === qty - 1 && qty === availablePlayerDelegates && playerHasLobbyDelegate);
                game.defer(new SendDelegateToArea_1.SendDelegateToArea(player, 'Select where to send delegate', { source: fromLobby ? 'lobby' : 'reserve' }));
            }
        });
    }
}
exports.VirtualDemocracy = VirtualDemocracy;
//# sourceMappingURL=VirtualDemocracy.js.map